<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Dedication</h1>
</div>
</div>
<div class="start">
<p class="center">
		For my husband,<br/>
		Larry Mills,<br/>
		whose faith in my abilities<br/>
		both inspires and prods.</p>
</div>
<p>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap139417.vue?236cc535